import LocalStorage from '../LocalStorage';

const key = 'last_url';

const LocalstorageLastUrl = {
    add: (url: string): void => {
        const urls = LocalstorageLastUrl.get();
        const newUrls = [url].concat(urls);

        if (newUrls.length > 2) {
            newUrls.pop();
        }

        LocalStorage.set(key, JSON.stringify(newUrls));
    },

    remove: (): void => {
        LocalStorage.remove(key);
    },

    get: (): string[] => {
        return JSON.parse(LocalStorage.get(key) ?? `[]`);
    },
};

export default LocalstorageLastUrl;
